module.exports = __webpack_public_path__ + "img/chat.56a4b4db.svg";